.loading:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  animation: ellipsis 1000ms infinite steps(3, end);
  content: '\2026'; /* ascii code for the ellipsis character */
  width: 0;
}

@keyframes ellipsis {
  75% {
    width: 1em;
  }
  to {
    width: 1em;
  }
}
